module.exports = __webpack_public_path__ + "img/team_ben.5a03eead.jpg";